<template>
  <div>
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      We need to verify your identity one more time before you can edit your
      payment details.
      <br />
      <br />
      {{ getMainText() }}
    </h4>
    <form-field
      id="verification_code"
      type="text"
      label="Verification Code"
      :value="verification_code"
      placeholder="Enter Verification Code"
      :on-input="onInput"
      name="verification_code"
      :pattern="'number'"
    />
    <p class="-mt-1 text-left text-gray-over-dark">
      Note: All users of this carrier will receive a notification of any changes
      made to payment details.
    </p>
  </div>
</template>

<script>
import FormField from '../../FormField.vue';

export default {
  name: 'PaymentVerification',
  components: {
    'form-field': FormField,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      verification_code: '',
    };
  },
  computed: {
    paymentErrors() {
      return this.$store.state.payments.errors;
    },
    isEmailRequiredForLogin: function () {
      return (
        this.$store.state.carriers.isEmailRequiredForLogin ||
        this.$store.state.carriers.carrierData?.identity
          ?.is_email_required_for_login
      );
    },
  },
  methods: {
    onInput(e) {
      this.verification_code = e.target.value;
      this.$store.dispatch('payments/updateNestedField', {
        path: 'verification_code',
        value: e.target.value,
      });
    },
    getMainText: function () {
      return this.isEmailRequiredForLogin
        ? 'Please enter the code we just sent to your email address.'
        : 'Please enter the code we just sent to your mobile phone number.';
    },
  },
};
</script>
